export default __webpack_public_path__ + "static/media/iconPhoneBlue.51a65b09.svg";